'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { ArrowLeftXs } from '@lichtblick/photon/icons/arrows/arrow-left-xs';
import { ArrowRightXs } from '@lichtblick/photon/icons/arrows/arrow-right-xs';
import { ExclamationMarkTriangleXs } from '@lichtblick/photon/icons/symbols/exclamation-mark-triangle-xs';
import { Duration } from '@lichtblick/theme';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import styles from './funnel-slider-track.module.scss';
export const FunnelSliderTrack = ({ current: CurrentComponent, funnelState, isAtStart, isPending, onBackClick, previous: PreviousComponent })=>{
    const [isAnimating, setIsAnimating] = useState(false);
    const [direction, setDirection] = useState();
    const isLastStep = funnelState.currentStep === 'email';
    const onSubmit = useCallback(()=>{
        !isAnimating && setDirection('right');
    }, [
        isAnimating
    ]);
    const onBackButtonClick = useCallback((event)=>{
        event.preventDefault();
        if (isAnimating || isPending) {
            return;
        }
        setDirection('left');
        onBackClick(event);
    }, [
        isAnimating,
        isPending,
        onBackClick
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
    useEffect(()=>{
        if (direction && !isPending) {
            setIsAnimating(true);
            setTimeout(()=>setIsAnimating(false), Duration.LargeIntro);
        }
    }, [
        funnelState.currentStep
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles['slider-track'], isAnimating && styles.transition, isAnimating && direction && styles[direction], direction === 'left' && styles.reverse),
                children: [
                    isAnimating && PreviousComponent,
                    CurrentComponent
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles['slider-track-actions'],
                children: [
                    !isAtStart && /*#__PURE__*/ _jsx(TextCTA, {
                        as: "button",
                        "data-testid": "back-button",
                        icon: /*#__PURE__*/ _jsx(ArrowLeftXs, {}),
                        onClick: onBackButtonClick,
                        type: "button",
                        children: "Zurück"
                    }),
                    /*#__PURE__*/ _jsx(BoxCTA, {
                        as: "button",
                        "data-testid": "submit-button",
                        loading: isPending,
                        onClick: onSubmit,
                        type: isAnimating || isPending ? 'button' : 'submit',
                        wide: isAtStart,
                        children: /*#__PURE__*/ _jsxs("span", {
                            className: styles['cta-text'],
                            children: [
                                isLastStep ? 'Angebot einholen' : 'Weiter',
                                /*#__PURE__*/ _jsx(ArrowRightXs, {
                                    className: "icon"
                                })
                            ]
                        })
                    }),
                    funnelState.errors?.generic && /*#__PURE__*/ _jsxs("div", {
                        className: styles['error-banner'],
                        children: [
                            /*#__PURE__*/ _jsx(ExclamationMarkTriangleXs, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                size: "s",
                                children: funnelState.errors.generic
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=funnel-slider-track.js.map